import React, { Fragment } from "react";
import Progress from "./Progress";
import { Container, Row, Col } from "react-bootstrap";
import { useWindowDimensions } from "./windowDimensions";
export default function ProgressComponent(props) {
  const { height, width } = useWindowDimensions();
  return (
    <Container>
      {props.isLoading && (
        <Row>
          <Col sm={12}>
            <div
              style={
                width > 765
                  ? {
                      // desktop view
                      position: "absolute",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      left: "30%",
                      // top: "100px",
                      zIndex: "999",
                      // opacity: "0.5",
                    }
                  : {
                      // mobile view
                      width: "100%",
                      height: "50px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      marginTop: "5px",
                      marginBotton: "5px",
                    }
              }
            >
              <Progress
                percent={props.percent}
                setProgressPercentage={props.setProgressPercentage}
                percent2={props.percent2}
                grid={true}
                value={props.value}
                isLoading={props.isLoading}
                stop={props.stop}
              />
            </div>
          </Col>
        </Row>
      )}
    </Container>
  );
}
